import BaseClient from './BaseClient';

class GroupInvitationsClient extends BaseClient {
    listInvitations(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/invitations`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    invitationsCount(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/invitations/count`;
        return this.makeCoreApiRequest(url, 'get', null, params);
    }

    sendInvitation(teamId, groupId, params) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/invitations`;
        return this.makeCoreApiRequest(url, 'post', params);
    }

    resendInvitation(teamId, groupId, invitationId) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/invitations/${invitationId}`;
        return this.makeCoreApiRequest(url, 'post');
    }

    deleteInvitation(teamId, groupId, invitationId) {
        const url = `/api/v3/teams/${teamId}/groups/${groupId}/invitations/${invitationId}`;
        return this.makeCoreApiRequest(url, 'delete');
    }
}

export default new GroupInvitationsClient();
